import React, { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogContent,
  TextField,
  Button,
  Typography,
  IconButton,
  Box,
  InputAdornment,
  useTheme,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";

import useMediaQuery from "@mui/material/useMediaQuery";
import { motion } from "framer-motion";
import { trackLead } from "../../../utils/fbConversion";

const inputStyle = {
  background: "#ffffff",
  borderRadius: "12px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
    "& fieldset": { borderColor: "#e4e4e7" },
    "&:hover fieldset": { borderColor: "#b9b9c3" },
    "&.Mui-focused fieldset": { borderColor: "#5e17eb" },
  },
};

const StillNotSurePopUpv2 = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // ----------------- 🔹 Added Logic (from GetInTouchReact) -----------------
  const [gclid, setGclid] = useState("");
  const [formError, setFormError] = useState("");

  const [formValues, setFormValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    website: window.location.href.slice(0, 250),
    description: window.location.href.includes("full-stack-web-development")
      ? "Full Stack Web Development"
      : window.location.href.includes("devops-and-cloud-training-online")
      ? "DevOps and Cloud with GenAI Master Program"
      : "DevOps and Cloud with GenAI Job Ready Program",
  });

  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });

  const formRef = useRef(null);

  const validateFirstName = (v) => (!v ? "First name is required" : "");
  const validateLastName = (v) => (!v ? "Last name is required" : "");
  const validateEmail = (v) =>
    !v
      ? "Email is required"
      : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)
      ? ""
      : "Invalid email address";
  const validatePhone = (v) =>
    !v
      ? "Phone number is required"
      : /^\d{10}$/.test(v)
      ? ""
      : "Phone number must be 10 digits";

  const handleChange = (e, field) => {
    const value = e.target.value;

    setFormValues({ ...formValues, [field]: value });

    let error = "";
    if (field === "firstName") error = validateFirstName(value);
    if (field === "lastName") error = validateLastName(value);
    if (field === "email") error = validateEmail(value);
    if (field === "phone") error = validatePhone(value);

    setErrors({ ...errors, [field]: error });
  };

  useEffect(() => {
    const urlGclid = new URLSearchParams(window.location.search).get("gclid");
    if (urlGclid) {
      localStorage.setItem("gclid", urlGclid);
      setGclid(urlGclid);
    } else {
      setGclid(localStorage.getItem("gclid"));
    }
  }, []);

  const handleFormSubmit = (event) => {
    event.preventDefault();

    const firstNameError = validateFirstName(formValues.firstName);
    const lastNameError = validateLastName(formValues.lastName);
    const emailError = validateEmail(formValues.email);
    const phoneError = validatePhone(formValues.phone);

    if (firstNameError || lastNameError || emailError || phoneError) {
      setErrors({
        firstName: firstNameError,
        lastName: lastNameError,
        email: emailError,
        phone: phoneError,
      });

      setFormError(
        firstNameError || lastNameError || emailError || phoneError
      );
      return;
    }

    trackLead({
      contentName: "Still Not Sure",
      email: formValues.email,
      phone: formValues.phone,
      firstName: formValues.firstName,
      lastName: formValues.lastName,
    });

    if (formRef.current) formRef.current.submit();
  };
  // -------------------------------------------------------------------------

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md"
      PaperProps={{ sx: { borderRadius: "18px", overflow: "hidden" } }}>
      
      <IconButton 
        aria-label="Close Free Consultation Form"
        onClick={onClose}
        sx={{ position: "absolute", right: 14, top: 14, zIndex: 10 }}>
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 0 }}>
        <Box display="flex" flexDirection={isMobile ? "column" : "row"}>

          {!isMobile && (
            <Box flex={1} sx={{ display:"flex", justifyContent:"center", alignItems:"center", background:"#ffffff" }}>
              <img loading="lazy" src={"https://img.freepik.com/free-photo/doubtful-uncertain-student-asks-why-she-should-choose-something-shrugs-shoulders-looks-suspiciously_273609-18820.jpg?t=st=1730547330~exp=1730550930~hmac=259b91522ac4020eacfbf2b781342457749b7acf29d5b14c998286a1cb7b4d24&w=740"} alt="Consultation Offer"
                style={{ width:"100%", height:"100%", objectFit:"cover" }} />
            </Box>
          )}

          <Box flex={1} sx={{ p:{ xs:3, md:4 } }}>
            <motion.div initial={{ opacity:0, y:25 }}
              animate={{ opacity:1, y:0 }} transition={{ duration:.35 }}>

              <Typography variant="h5" fontWeight={700} mb={1} sx={{ fontFamily: "Poppins, sans-serif" }}>
                Still Not Sure?
              </Typography>

              <Typography color="text.secondary" mb={3} sx={{ fontFamily: "Poppins, sans-serif" }}>
                Talk to Our Expert Consultant
              </Typography>

              {/* 🔹 Wrapped form around fields (Zoho form) */}
              <form
                ref={formRef}
                id="WebToLeads774394000000902049"
                name="WebToLeads774394000000902049"
                action="https://crm.zoho.in/crm/WebToLeadForm"
                method="POST"
                onSubmit={handleFormSubmit}
                acceptCharset="UTF-8"
              >
                <input type="hidden" name="xnQsjsdp"
                  defaultValue="7d15d6ae01d5e4e362e4c5030d41265b910e3619da9c7a66ed4112cfbcdc414b"/>
                <input type="hidden" name="xmIwtLD"
                  defaultValue="44e1da7b6f7318fd661008fffb32f7aee45ebf52e977f8bcabba7a19c3c67dd9d51c23bfa87adc62bc6ea1224971de37"/>
                <input type="hidden" name="actionType" defaultValue="TGVhZHM="/>
                <input type="hidden" name="returnURL" defaultValue="https://paperlive.in/thankyou"/>
                <input type="hidden" name="zc_gad" value={gclid} />

                <Box sx={{ display: "grid", gap: "14px" }}>
                  <TextField
                    label="First Name"
                    value={formValues.firstName}
                    onChange={(e) => handleChange(e, "firstName")}
                    name="First Name"
                    fullWidth variant="outlined" sx={inputStyle}
                    InputProps={{ startAdornment: (
                      <InputAdornment position="start"><AssignmentIndIcon/></InputAdornment>) }}
                    error={!!errors.firstName}
                  />

                  <TextField
                    label="Last Name"
                    value={formValues.lastName}
                    onChange={(e) => handleChange(e, "lastName")}
                    name="Last Name"
                    fullWidth variant="outlined" sx={inputStyle}
                    InputProps={{ startAdornment: (
                      <InputAdornment position="start"><AssignmentIndIcon/></InputAdornment>) }}
                    error={!!errors.lastName}
                  />

                  <TextField
                    label="Email"
                    value={formValues.email}
                    onChange={(e) => handleChange(e, "email")}
                    name="Email" type="email"
                    fullWidth variant="outlined" sx={inputStyle}
                    InputProps={{ startAdornment: (
                      <InputAdornment position="start"><EmailIcon/></InputAdornment>) }}
                    error={!!errors.email}
                  />

                  <TextField
                    label="Phone Number"
                    value={formValues.phone}
                    onChange={(e) => handleChange(e, "phone")}
                    name="Phone" type="tel"
                    fullWidth variant="outlined" sx={inputStyle}
                    InputProps={{ startAdornment: (
                      <InputAdornment position="start"><PhoneIphoneIcon/></InputAdornment>) }}
                    error={!!errors.phone}
                  />

                  <TextField name="Website" value={formValues.website} style={{ display: "none" }} />
                  <TextField name="Description" value={formValues.description} style={{ display: "none" }} />
                </Box>

                <div style={{ color: "red", marginTop: 6 }}>{formError}</div>

                <Button
                  aria-label="Submit Still Not Sure Form"
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 1,
                    borderRadius: "12px",
                    fontWeight: 700,
                    height: 45,
                    textTransform: "none",
                    background: "#5e17eb",
                    ":hover": { background: "#4d13c6" },
                  }}
                  type="submit"
                >
                  Submit
                </Button>
              </form>
            </motion.div>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default StillNotSurePopUpv2;